import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import './toast_notifications.css';

const ToastNotifications = ({ notifications = [], onDismiss }) => {
  const [visibleNotifications, setVisibleNotifications] = useState([]);

  useEffect(() => {
    setVisibleNotifications(notifications);
  }, [notifications]);

  const handleDismiss = (id) => {
    setVisibleNotifications(prev => prev.filter(n => n.id !== id));
    if (onDismiss) {
      onDismiss(id);
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'error':
        return '⚠️';
      case 'warning':
        return '⚠️';
      case 'success':
        return '✅';
      case 'info':
        return 'ℹ️';
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className="toast-container">
      {visibleNotifications.map((notification) => (
        <div
          key={notification.id}
          className={`toast toast--${notification.type}`}
          role="alert"
          aria-live="polite"
        >
          <div className="toast__content">
            <span className="toast__icon">{getIcon(notification.type)}</span>
            <div className="toast__message">
              <strong className="toast__title">{notification.title}</strong>
              {notification.message && (
                <p className="toast__text">{notification.message}</p>
              )}
            </div>
          </div>
          <button
            className="toast__close"
            onClick={() => handleDismiss(notification.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastNotifications;
